import JQueryView, { on } from '../../../../common/views/jqueryView';
import $ from 'jquery';

export default class FormView extends JQueryView {
  image: string | ArrayBuffer | null;

  constructor(image: string) {
    super('.simple_form');
    this.image = image;
    this.render();
  }

  @on({ event: 'change', selector: '#user_image' })
  onChangeImage(event: JQuery.ChangeEvent<HTMLInputElement>) {
    if (event.target.files.length > 0) {
      const fr = new FileReader();

      fr.onload = () => {
        this.image = fr.result;
        this.render();
      };
      fr.readAsDataURL($(event.target).prop('files')[0]);
    }
  }

  render() {
    if (this.image !== '') {
      $('#preview').css('background-image', `url(${this.image})`).show();
    }
  }
}
